/** Same definition as backend churnService: deletions / (additions + deletions). */
export function commitChurnRatio(additions, deletions) {
  const a = Number(additions) || 0;
  const d = Number(deletions) || 0;
  const total = a + d;
  if (total <= 0) return null;
  return d / total;
}

export function formatRepoTabDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function commitSearchBlob(row) {
  const sd = row.sensitiveDataDetection;
  const patternBlob = sd && Array.isArray(sd.patterns) ? sd.patterns.join(' ') : '';
  const confBlob = sd && sd.confidence ? String(sd.confidence) : '';
  const parts = [
    row.sha,
    row.message,
    row.authorName,
    row.authorEmail,
    row.authorGithub,
    row.branch,
    row.changedFiles != null ? String(row.changedFiles) : '',
    patternBlob,
    confBlob,
  ];
  return parts.filter(Boolean).join(' ').toLowerCase();
}

export function activitySearchBlob(row) {
  const parts = [row.type, row.title, row.description, row.actorFullName, row.actor];
  return parts.filter(Boolean).join(' ').toLowerCase();
}

export function prSearchBlob(row) {
  const labelParts = Array.isArray(row.labels)
    ? row.labels.map((l) => (typeof l === 'string' ? l : l?.name)).filter(Boolean)
    : [];
  const assigneeParts = Array.isArray(row.assignees) ? row.assignees : [];
  const reviewerParts = Array.isArray(row.requestedReviewers) ? row.requestedReviewers : [];
  const parts = [
    row.number != null ? String(row.number) : '',
    row.title,
    row.name,
    row.authorName,
    row.author,
    row.state,
    row.status,
    row.headBranch,
    row.baseBranch,
    row.changedFiles != null ? String(row.changedFiles) : '',
    row.additions != null ? String(row.additions) : '',
    row.deletions != null ? String(row.deletions) : '',
    row.commitCount != null ? String(row.commitCount) : '',
    row.mergeCommitSha != null ? String(row.mergeCommitSha) : '',
    row.draft ? 'draft' : '',
    ...labelParts,
    ...assigneeParts,
    ...reviewerParts,
  ];
  return parts.filter(Boolean).join(' ').toLowerCase();
}

/** GitHub commit page URL from API htmlUrl or owner/repo + sha. */
export function commitGitHubUrl(row) {
  const u = row.htmlUrl && String(row.htmlUrl).trim();
  if (u) return u;
  const sha = row.sha && String(row.sha).trim();
  const full = row.repository && String(row.repository).trim();
  if (sha && full && /^[^/\s]+\/[^/\s]+$/.test(full)) {
    return `https://github.com/${full}/commit/${sha}`;
  }
  return null;
}

/** GitHub `/tree/{branch}` URL when repo is `owner/name`. */
export function githubRepoBranchUrl(repositoryFullName, branchName) {
  const full = repositoryFullName && String(repositoryFullName).trim();
  const br = branchName != null ? String(branchName).trim() : '';
  if (!full || !br || !/^[^/\s]+\/[^/\s]+$/.test(full)) return null;
  return `https://github.com/${full}/tree/${encodeURIComponent(br)}`;
}

/** GitHub tree (branch) URL for a commit row. */
export function commitBranchGitHubUrl(row) {
  return githubRepoBranchUrl(row.repository, row.branch);
}

export function formatFilesChanged(n) {
  const x = Number(n);
  if (!Number.isFinite(x) || x < 0) return '—';
  if (x === 1) return '1 file changed';
  return `${x} files changed`;
}

export function commitAuthorDisplay(row) {
  return row.authorName || row.authorEmail || row.authorGithub || 'Unknown';
}
